export type Simplify<T> = { [K in keyof T]: T[K] };

export type SetRequired<T, K extends keyof T> = Simplify<
  Required<Pick<T, K>> & Omit<T, K>
>;

export type Unpacked<T> = T extends readonly (infer U)[] ? U : T;

export type ValueOf<T, K extends keyof T = keyof T> = T[K];

export type Truthy<T> = T extends false | '' | 0 | null | undefined ? never : T;

export const isTruthy = <T>(value: T): value is Truthy<T> => {
  return Boolean(value);
};
